/**
 * PhonePe checkout — redirect-based UPI flow.
 *
 * Usage:
 *   import { openPhonePe } from "@/lib/phonepe";
 *   await openPhonePe({
 *     kind: "invoice", ref_id: invoiceId,
 *     onFailure: (e) => { ... },  // called only if order creation fails.
 *                                  // On success we redirect off-page; the
 *                                  // /payment-result page then polls and
 *                                  // navigates the user back with a toast.
 *   });
 */
import { api, apiError } from "./api";
import { toast } from "sonner";

/**
 * @param {Object} opts
 *  - kind: "invoice" | "tournament_team" | "donation" | "wallet_topup" | "membership"
 *  - ref_id: id
 *  - amount: rupees (donation / wallet_topup only)
 *  - donor: { name, email, phone, pan, address } (donation only)
 *  - member_id: string (membership only)
 *  - return_to: optional path to send user back to after payment
 *  - onFailure(e)
 */
export async function openPhonePe(opts) {
  try {
    const { data } = await api.post("/payments/phonepe/order", {
      kind: opts.kind,
      ref_id: opts.ref_id,
      amount: opts.amount,
      donor: opts.donor,
      member_id: opts.member_id,
    });
    if (!data.redirect_url) throw new Error("PhonePe did not return a redirect URL");

    // Remember where to send the user after payment result
    if (opts.return_to) {
      try { sessionStorage.setItem(`pp_return_${data.txn_id}`, opts.return_to); } catch (_) {}
    }
    // Off we go to PhonePe's hosted checkout
    window.location.assign(data.redirect_url);
  } catch (e) {
    toast.error(apiError(e));
    if (opts.onFailure) opts.onFailure(e);
  }
}
